var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-widget',{attrs:{"model":_vm.model,"attribute":_vm.attribute,"label":_vm.label,"options":_vm.options,"type":"select2","display-field":"${item.name}","value-field":"key","hint":_vm.hint,"items":_vm.availableLanguages}})}
var staticRenderFns = []

export { render, staticRenderFns }